export const tokenConfig = () => {
    const token = localStorage.getItem('token')
    var config = {
        headers:{}
    }
    config.headers['x-auth-token'] = token

    return config
}

